import { createContext, useContext } from "react";

export type ConfirmUnsavedChanges = (message: string) => Promise<boolean>;
export type RegisterUnsavedChangesGuard = (
	id: symbol,
	enabled: boolean,
) => () => void;

export type UnsavedChangesContextValue = {
	confirmUnsavedChanges: ConfirmUnsavedChanges;
	hasUnsavedChanges: boolean;
	registerGuard: RegisterUnsavedChangesGuard;
};

export const UnsavedChangesContext =
	createContext<UnsavedChangesContextValue | null>(null);

export function useUnsavedChangesDialog(): ConfirmUnsavedChanges | null {
	return useContext(UnsavedChangesContext)?.confirmUnsavedChanges ?? null;
}

export function useHasUnsavedChanges(): boolean {
	return useContext(UnsavedChangesContext)?.hasUnsavedChanges ?? false;
}

export function useRegisterUnsavedChangesGuard(): RegisterUnsavedChangesGuard | null {
	return useContext(UnsavedChangesContext)?.registerGuard ?? null;
}
